import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../../containers/MainLayout";
import { connect } from "react-redux";
import { getPharmacoVigilance } from "../../services/pharmacovigilance";
import Loader from "../../baseComponents/Loader";
import ReportForm from "./components/ReportForm";
import PageTitle from "../../baseComponents/PageTitle";

import titleLogo from "../../assets/images/title-icons/Eye-Line.svg";
import { ReactComponent as Logo } from "../../assets/images/title-icons/Eye-Line.svg";

import "./index.css";

const PharmacoVigilance = (props) => {
  const { lang } = props.settings;
  const [isFetching, setIsFetching] = useState(true),
    [extras, setExtra] = useState({}),
    [activeClass, setActiveClass] = useState(""),
    [titleActive, setTitleActive] = useState(0),
    [pageData, setPageData] = useState({}),
    [formData, setFormData] = useState({}),
    [dataCommitmentAndReport, setDataCommitmentAndReport] = useState([]),
    formRef = useRef(null),
    [pharmacoVigilanceData, setPharmacoVigilanceData] = useState({});

  const getInitialData = async () => {
    try {

      const response = await getPharmacoVigilance();
      console.log(response)
      const { info_page, section_form, extras } = response.data[lang];
      setPharmacoVigilanceData(response.data);
      setExtra(extras)
      setPageData(info_page);
      setFormData(section_form);
      setDataCommitmentAndReport(info_page.commitment.body);
      setIsFetching(false);
      if (props.location.hash && props.location.hash === '#contacto') {
        setTimeout(() => {
          formRef.current.scrollIntoView({ behavior: "smooth" });
        }, 500);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Object.entries(pharmacoVigilanceData).length !== 0) {
      const { info_page, section_form } = pharmacoVigilanceData[lang];
      setPageData(info_page);
      setFormData(section_form);
      setDataCommitmentAndReport(info_page.commitment);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    getInitialData();
    let timeout = null;
    timeout = setTimeout(() => {
      setActiveClass("active");
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isFetching) return <Loader />;

  let title = pageData.title ? pageData.title : "",
    label = pageData.subtitle ? pageData.subtitle : "";

  return (
    <MainLayout
      id="pharmacoVigilance"
      className={`${activeClass}`}
      logo={<Logo />}
    >
      <div className='pharmacoVigilance-cover' />
      <div className="main-container transition">
        <div className="gray-line" />

        <div className="section-info">
          <div className="title-info">
            <PageTitle title={title} label={label} logo={titleLogo} />
            <div className="align-left">
              <div
                className="report-button"
                onClick={() => {
                  formRef.current.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {pageData.title_report_button}
              </div>
            </div>
          </div>
          <div className="body-info">
            <div className="definition">
              <div className="title-definition">{pageData.title_body}</div>

              {/* {pageData.body.map((item) => {
                return <p>{item.content}</p>;
              })} */}
              <div dangerouslySetInnerHTML={{ __html: pageData.body }}></div>
              {/* <p>{pageData.body}</p> */}
              <div className="red-box">
                <div className="white-line " />
                {/* <p>{pageData.key_paragraph}</p> */}

                <div
                  dangerouslySetInnerHTML={{ __html: pageData.key_paragraph }}
                ></div>
              </div>
            </div>
            <div className="commitment-report">
              <div className="titles-commitment-report">
                <div
                  className={`${titleActive === 0 ? "title-active" : ""}`}
                  onClick={() => {
                    setTitleActive(0);
                    setDataCommitmentAndReport(pageData.commitment.body);
                  }}
                >
                  {pageData.title_commitment}{" "}
                </div>
                <div
                  className={`${titleActive === 1 ? "title-active" : ""}`}
                  onClick={() => {
                    setTitleActive(1);
                    setDataCommitmentAndReport(pageData.report.body);
                  }}
                >
                  {pageData.title_report}{" "}
                </div>
              </div>

              <div
                className='color-gray'
                dangerouslySetInnerHTML={{ __html: dataCommitmentAndReport }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className="report" ref={formRef}>
        <ReportForm data={formData} extras={extras} lang={lang} />
      </div>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(PharmacoVigilance);
